module.exports = __webpack_public_path__ + "static/media/gunji.72612513.ogg";